import {
  ActionLogoutUser,
  ActionTryLogin,
  ActionTrySuccess
} from ".";
import { ActionLogoutSuccess, ActionValidateLogin, ActionLoginFail, ActionFirebaseAuthentication } from "./login-actions";
import { Actions, Effect } from "@ngrx/effects";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import {
  LoginServices,
  PubSubService,
  StorageService,
  StoreDetailService,
  FirebaseCatalogService
} from "@tendercuts/providers";
import { of } from "rxjs";
import { ofAction } from "ngrx-actions";
import { Store, User, GenericError } from "@tendercuts/models";
import { GeneratedFile } from '@angular/compiler';
import * as firebase from 'firebase';

@Injectable()
export class AuthEffects {
  KEY = "user22";

  constructor(
    private actions$: Actions,
    private authService: LoginServices,
    private storeService: StoreDetailService,
    private firebaseCatalogService: FirebaseCatalogService,
    private events: PubSubService,
    private storage: StorageService
  ) { }

  @Effect() authLogin = this.actions$.pipe(
    ofAction(ActionTryLogin),
    switchMap(action => {
      return this.authService.getData(action.payload).pipe(
        map((user: User[]) => {
          if (!user[0].isValid || !user[0].isPosUser) {
            return new ActionLoginFail("Login Credentials Failed");
          } else {
            return new ActionValidateLogin(user[0]);
          }
        }),
        catchError(err => {
          return of(new ActionLoginFail("Login Credentials Failed"));
        })
      );
    })
  );

  /**
   * 1.Filter the pos stores
   * 2.Given user storeId matched pos stores call the ActionTrySuccess
   * 3.else throw error
   */
  @Effect() validLogin = this.actions$.pipe(
    ofAction(ActionValidateLogin),
    switchMap((action: ActionValidateLogin) => {
      return this.storeService.getData().pipe(
        map((stores: Store[]) => {
          if (window.location.href.indexOf('envee') !== -1) {
            if (!action.user.isEnveeUser) {
              return new ActionLoginFail('Trying to login with Tendercuts POS credentials');
            }
          } else {
            if (action.user.isEnveeUser) {
              return new ActionLoginFail('Trying to login with Envee POS credentials');
            }
          }
          const selectedStore = stores.filter(
            store =>
              store.storeAttribute &&
              (store.storeAttribute.storeType === 1 || store.storeAttribute.storeType === 3) &&
              store.storeId === action.user.storeId[0]
          )[0];
          if (!selectedStore) {
            return new ActionLoginFail('Trying to load online store. please contact tech support');
          }
          return new ActionFirebaseAuthentication(action.user);
        }),

        catchError(err => {
          return of(new ActionLoginFail("Login Credentials Failed"));
        })
      );
    })
  );

  @Effect() firebaseAuth = this.actions$.pipe(
    ofAction(ActionFirebaseAuthentication),
    mergeMap((action: ActionFirebaseAuthentication) => {
      return firebase.auth().signInWithCustomToken(action.user.fsToken)
        .then((data) => {
          this.storage.storeData("pos_user", action.user);
          this.events.$pub("user:login", action.user);
          return new ActionTrySuccess(action.user);
        })
        .catch((err) => {
          return new ActionLoginFail('Please contact tech support, FBA failed');
        });
    })
  );

  @Effect() logout = this.actions$.pipe(
    ofAction(ActionLogoutUser),
    mergeMap((action: ActionLogoutUser) => {
      this.storage.removeData("pos_user");
      this.firebaseCatalogService.unSubscription();
      firebase.auth().signOut();
      return [new ActionLogoutSuccess()];
    })
  );
}
